// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"p5-z"};